import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		request_error: false,
		request_error_text: '抱歉，服务器出现问题',
		is_login: false,
		show_login: false,
		base_info: {}
	},
	mutations: mutations
});
export default store


// WEBPACK FOOTER //
// ./src/store/index.js